module.exports = __webpack_public_path__ + "img/su.c03cb472.jpg";